const func = $target => {
	$(window)
		.on('scroll', function() {
			var scroll = $(window).scrollTop();
			if (scroll >= $target.parents('section').outerHeight()) {
				$target.addClass('active');
			} else {
				$target.removeClass('active');
			}
		})
		.trigger('scroll');
};

export default func;
